import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import apolloClient from './lib/apolloClient';
import './i18n';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')).render(
  <ReduxProvider store={store}>
    <ApolloProvider client={apolloClient}>
      <Router>
        <App />
      </Router>
    </ApolloProvider>
  </ReduxProvider>
);
